import React, {useContext, useState, useEffect} from "react";
import { contextApp } from "../../../App/contextApp";
import { Container, Row, Col } from 'reactstrap';
import Servicios from "./Servicios/Servicios";
import './ComplaintDetailMostrador.scss'
import Products from "./Products/Products";
import Times from "./Time/Time";
import language from './languaje.json';
import ProblemOrdering from "./ProblemOrdering/ProblemOrdering";
import ProblemPickingUpOrder from "./ProblemPickingUpOrder/ProblemPickingUpOrder";
import Other from "./Other/Other";
import Ticket from "./Ticket/Ticket";

const ComplaintDetailMostrador = (props) => {

    const { dataIncidences } = props;
    const { selectValue, currentLanguage, badgeBoxColors } = useContext(contextApp);
    const { monthsLabel } = selectValue;
    const [texts, setTexts] = useState(language.english);

    useEffect(()=>{

        if(currentLanguage === 'spanish') {

            setTexts(language.spanish)

        }

      

    },[currentLanguage])
    return(
        <Container>
            <Row className="mb-5">
                <Col xs="12">
                    <h4 className='emigre-bold text-secondary text-left text-uppercase'>
                        {texts.complaintsDetailbyCat}
                    </h4>
                </Col>
                <Col xs="12">
                    <Products badgeBoxColors={badgeBoxColors} dataIncidences={dataIncidences} monthsLabel={monthsLabel} texts={texts}/>
                </Col>
                <Col xs="12">
                    <Servicios badgeBoxColors={badgeBoxColors} dataIncidences={dataIncidences} monthsLabel={monthsLabel} texts={texts}/>
                </Col>
                <Col xs="12">
                    <Times badgeBoxColors={badgeBoxColors} dataIncidences={dataIncidences} monthsLabel={monthsLabel} texts={texts}/>
                </Col>
                <Col xs="12">
                    <Ticket badgeBoxColors={badgeBoxColors} dataIncidences={dataIncidences} monthsLabel={monthsLabel} texts={texts}/>
                </Col>
                <Col xs="12">
                    <Other badgeBoxColors={badgeBoxColors} dataIncidences={dataIncidences} monthsLabel={monthsLabel} texts={texts}/>
                </Col>
            </Row>  
           
        </Container>       
    );

}

export default ComplaintDetailMostrador;